import styled from 'styled-components';
import { StyledWidgetHeader } from 'components/base/common-styles';
import { StyledLoadingAlert } from 'components/base/empty-states/LoadingAlert/LoadingAlert.style';

export const StyledHeader = styled(StyledWidgetHeader)`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;

  & ${StyledLoadingAlert} {
    position: absolute;
    right: 0;
    top: 0.2rem;
    text-transform: none;
  }
`;
